import { Injectable, PipeTransform } from '@angular/core';
import { HttpInterceptorService } from '@ispm/core/services/http-interceptor.service';
import { Observable } from 'rxjs/Observable';
import { TranslateService } from '@ngx-translate/core';
import { BirthDateYearsPipe } from '@ispm/shared/pipes/birth-date-years.pipe';
import { BrowserCacheService } from "@ispm/core/services/browser-cache.service";
import { IDisplayElement } from '../interfaces/test-header-elements.interface';
import { TestMetaActionCreatorService } from './test-meta-action-creator.service';
import { map, switchMap } from 'rxjs/operators';

@Injectable()
export class TestHeaderElementsService {

  private getElementsUrl: string;

  private viewTemplates = {
    'BirthDateYears': new BirthDateYearsPipe(this.translateService)
  };

  constructor(
    private _http: HttpInterceptorService,
    private testHeaderAC: TestMetaActionCreatorService,
    private translateService: TranslateService,
    private browserCacheService: BrowserCacheService,
  ) {
    this.getElementsUrl = '/viewelements/getelements';
  }

  public getTemplateInstance(templateName: string): PipeTransform {
    const defaultTemplate = (a: string) => a;

    if (templateName in this.viewTemplates) {
      return this.viewTemplates[templateName];
    }

    return { transform: defaultTemplate };
  }

  public getHeaderElements(elements: Array<string>): Observable<Array<IDisplayElement>> {
    const elementsKey = elements.join(',');

    return this.testHeaderAC.getDisplayConfig(elementsKey).pipe(
      switchMap(headerElements => {
        if (headerElements) {
          return Observable.of(headerElements);
        }
        return this._http.get(this.getElementsUrl,
          { 'elements': elementsKey, 'cacheId': this.browserCacheService.getCacheId()}
        ).pipe(
          map(data => {
            const jsonData = data.json();
            this.testHeaderAC.setDisplayConfig(elementsKey, jsonData);

            return jsonData;
          }),
        );
      }),
    );
  }
}

